module.exports = __webpack_public_path__ + "img/bgr-texture.3498593.jpg";